var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.775,
    height: 93.674,
    viewBox: "0 0 79.775 93.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32399",
    x: 0,
    y: 0,
    width: 79.775,
    height: 93.674,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32399-2",
    "data-name": "Path 32399",
    d: "M25.729-17.05h3.64q6.508,0,6.508,5.626a11.676,11.676,0,0,1-.5,3.254,9.9,9.9,0,0,1-1.158,2.7H25.729V11.19H13.043V-5.467H-8.137q-8.935,0-13.348-2.923T-25.9-17.712A29.181,29.181,0,0,1-23.084-29.46a63.05,63.05,0,0,1,7.5-12.52A77.66,77.66,0,0,1-5.158-53.232,58.864,58.864,0,0,1,6.479-61.4a24.043,24.043,0,0,1,11.086-3.089,20.791,20.791,0,0,1,4.468.5,11.954,11.954,0,0,1,3.7,1.379ZM-10.453-28.633a16.241,16.241,0,0,0-2.317,7.391,3.424,3.424,0,0,0,1.655,3.254A11.872,11.872,0,0,0-5.6-17.05H13.043V-51.908A47.125,47.125,0,0,0,4-45.731,74.221,74.221,0,0,0-4.331-37.4,50.812,50.812,0,0,0-10.453-28.633Z",
    transform: "translate(34.9 70.48)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon4);
export default __webpack_public_path__ + "static/media/number-icon4.35d2b084d33fcfcaa17ab5013eb98000.svg";
export { ForwardRef as ReactComponent };